import api from '@/api/axiosApi'

export interface DistributionCenterRead {
  id: string
  external_id: string
  name: string
  code: string
  created_at: string
}

interface DistributionCentersResponse {
  data: DistributionCenterRead[]
  pagination: {
    skip: number
    limit: number
    total: number
    has_more: boolean
  }
}

export async function fetchDistributionCenters(): Promise<DistributionCentersResponse> {
  const response = await api.get<DistributionCentersResponse>(
    '/admin/distribution-centers',
    { params: { skip: 0, limit: 200 } }
  )
  return response.data
}

export interface DerivedDC {
  id: string
  code: string
  name: string
}

export async function fetchLineDistributionCenters(
  planId: string,
  versionId: string,
  lineId: string
): Promise<DerivedDC[]> {
  const response = await api.get<DerivedDC[]>(
    `/plans/${planId}/versions/${versionId}/lines/${lineId}/distribution-centers`
  )
  return response.data
}
